import './styles/article.scss';

import ArticleProgress from './scripts/modules/ArticleProgress.js';
import ArticleMarginalia from './scripts/modules/ArticleMarginalia.js';
import ArticleActs from './scripts/modules/ArticleActs.js';
import ArticleFootnotes from './scripts/modules/ArticleFootnotes.js';
import ArticleCharts from './scripts/modules/ArticleCharts.js';
import { initAudiobooks } from './scripts/audiobook.js';

import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', function() {
	// blog article: reading progress + marginalia + acts + footnote cards
	new ArticleActs();              // first: inject act markers
	new ArticleMarginalia();        // wraps figures for lightbox + lifts into right lane (desktop)
	new ArticleProgress();
	new ArticleFootnotes();         // hover-cards for footnote refs
	new ArticleCharts();            // ECharts figures (lazy, only if the article has any)

	// Lightbox for marginalia images (and any .glightbox in the article)
	GLightbox({
		selector: '.glightbox',
		loop: true,
		touchNavigation: true,
		closeOnOutsideClick: true,
	});

	// audiobook players — must run after article systems so word-wrapping
	// happens after ArticleActs/ArticleFootnotes have mutated the DOM
	initAudiobooks();
});
